import React from 'react';

export default function TermsOfService() {
  return (
    <div style={{ fontFamily: 'Lato', padding: '2rem' }}>
      <section>
        <h2>Cardacademy - Terms and Conditions</h2>
        <p>Last updated: July 6, 2025</p>

        <p>Welcome to Cardacademy! These Terms and Conditions ("Terms") govern your access to and use of our website (<b>www.cardacademy.co</b>) and related services (collectively referred to as the "Platform").</p>

        <h2>1. About Cardacademy</h2>
        <p>Cardacademy is a content platform dedicated to helping users understand, compare, and make informed decisions about credit cards in India. We provide blogs, guides, reviews, and educational resources. We do not offer any financial products ourselves nor do we guarantee approvals from financial institutions.</p>

        <h2>2. Acceptance of Terms</h2>
        <p>By accessing or using the Platform, you agree to be bound by these Terms. If you do not agree, please do not access or use the Platform. We may update these Terms from time to time. Continued use of the Platform after changes are posted constitutes acceptance of the revised Terms.</p>

        <h2>3. User Responsibilities</h2>
        <ol>
          <li>You agree to use the Platform for lawful purposes only.</li>
          <li>You will not impersonate any individual or entity, or provide false information.</li>
          <li>You will not use the Platform to distribute viruses, spam, or malicious content.</li>
          <li>You agree not to copy, scrape, or use our content for commercial purposes without written permission.</li>
        </ol>

        <h2>4. Content Ownership</h2>
        <p>All content published on Cardacademy including articles, comparisons, illustrations, and branding is owned by Cardacademy unless otherwise stated. You may not reproduce or distribute any material without our written consent.</p>

        <h2>5. Third-Party Links & Affiliate Disclosure</h2>
        <p>Our site may include links to third-party websites, such as banks or card issuers. Some of these links may be affiliate links, meaning we may earn a commission if you apply through them. However, our editorial opinions are independent, unbiased, and not influenced by affiliate partnerships.</p>

        <h2>6. No Financial Advice</h2>
        <p>Cardacademy is for informational purposes only and does not constitute financial, legal, or tax advice. Please consult with a qualified professional before making any financial decisions. We are not liable for any action taken based on the information provided on this website.</p>

        <h2>7. Privacy</h2>
        <p>We collect and process data in accordance with our <a href="/privacy-policy">Privacy Policy</a>. By using the Platform, you consent to such processing and warrant that all data provided by you is accurate.</p>

        <h2>8. Limitation of Liability</h2>
        <p>Cardacademy will not be liable for any direct, indirect, incidental, or consequential damages resulting from the use or inability to use the Platform or from any content or links contained on the Platform.</p>

        <h2>9. Intellectual Property</h2>
        <p>Cardacademy, its logo, design, and original content are the intellectual property of Cardacademy. Unauthorized use of our content or branding may result in legal action.</p>

        <h2>10. Termination</h2>
        <p>We reserve the right to restrict or terminate your access to the Platform at any time without notice if you violate these Terms or abuse the service.</p>

        <h2>11. Governing Law</h2>
        <p>These Terms shall be governed by and construed in accordance with the laws of India. All disputes arising out of or relating to the Platform shall be subject to the exclusive jurisdiction of the courts located in Pune, Maharashtra.</p>

        <h2>12. Contact Us</h2>
        <p>If you have any questions or concerns about these Terms, feel free to contact us at: <b>joincardacademy@gmail.com</b></p>
      </section>
    </div>
  );
}
